import { Component, OnInit } from '@angular/core';
import { environment } from "../environments/environment";
import { SeguridadService } from './seguridad/seguridad.service';
import { ActivatedRoute, Router } from '@angular/router'; // Importa Router de '@angular/router'
import { CookieService } from 'ngx-cookie-service';
 
declare let abrirModal: Function;
declare let cerrarModal: Function;
 
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  parametrosDeRuta: any[];
  mostrarMensajeSesion: boolean = false;
  entorno: string;
  puedeVisualizar: number = 1;
 
  constructor(
    private route: ActivatedRoute,
    private seguridadService: SeguridadService,
    private cookieService: CookieService,
    private router: Router // Importa Router en lugar de Routes
  ) {}
 
  async ngOnInit() {
    this.entorno = `Entorno: ${
      (environment.applicationId == 11) ? 'Desarrollo' :
      (environment.applicationId == 12) ? 'Pruebas' :
      (environment.applicationId == 13) ? 'Preproducción' : ''
    }`;
 
    this.route.queryParams.subscribe(async params => {
      let portalFlag: boolean = false;
      let keys = Object.keys(params);
      if (keys.length > 0) {
        sessionStorage.clear();
        // await this.seguridadService.obtenerToken();
        keys.forEach(
          async key => {
            let value = params[key];
             // value = value.replace("%2B", "+").replace("%3D", "=");
            value = await this.seguridadService.desencriptar(value);
            let CodUsuarioSISE = await this.seguridadService.UsersAccess(value);
            key = key.toLowerCase();
            sessionStorage.setItem(key, value);
            if (key == "cod_agt")
              portalFlag = true;
            if(key == "cod_suc"){
              if((value == 800) && CodUsuarioSISE != 2)
              this.puedeVisualizar = 3;
            return;
            }            
            if (CodUsuarioSISE == 2) {
              this.puedeVisualizar = 2;
              
              return;
            }
          }
        );
 
        this.cookieService.set("returnUrl",
          (portalFlag) ? 'https://www.solidariaweb.com.co/intermediarios/index.aspx'
            : 'https://www.solidaria.com.co/soligespro/account/index');
      }
      setInterval(() => this.verificarTiempoSesion(), 3600 * 1000); //3600 * 1000 = 1 hora
    });
  }
 
  verificarTiempoSesion() {
    if (this.mostrarMensajeSesion)
      return;
    let tiempoSesion = this.cookieService.get("fechaExpiracionSesion");
    if (!tiempoSesion) {
      let fechaActual = new Date();
      let fechaExpiracion = new Date(
        fechaActual.getFullYear(),
        fechaActual.getMonth(),
        fechaActual.getDate(),
        fechaActual.getHours() + 3,
        fechaActual.getMinutes(),
        fechaActual.getSeconds()
      );
      this.cookieService.set("fechaExpiracionSesion", fechaExpiracion.toString());
    }
    else {
      if (new Date(tiempoSesion) < new Date()) {
        this.mostrarMensajeSesion = true;
        abrirModal('SesionFinalizada', false);
      }
    }
  }
 
  aceptarMensajeSesion() {
    this.mostrarMensajeSesion = false;
    this.cookieService.delete("fechaExpiracionSesion");
    cerrarModal("SesionFinalizada");
    let returnUrl = this.cookieService.get("returnUrl");
    window.location.replace(returnUrl);
  }
}